import { CookieRef } from "#app";
import { IGamingExclusion, ISessionLimitCookie } from "~/types/responsible-gaming/responsible-gaming";

const shouldNotify: Ref<Boolean> = ref(false);
const sessionTimer: Ref<NodeJS.Timeout | null> = ref(null);
const cookieKey = "session_limit";

const useSessionLimit = () => {
	const sessionCookie: CookieRef<ISessionLimitCookie | null | undefined> = useCookie(cookieKey);
	if (sessionCookie.value) {
		const sessionEnd = new Date(sessionCookie.value.sessionStart);

		sessionEnd.setMinutes(sessionEnd.getMinutes() + sessionCookie.value.periodValue);

		if (sessionEnd < new Date()) {
			shouldNotify.value = true;
		} else {
			const timeTillNotify = sessionEnd.getTime() - new Date().getTime();

			if (sessionTimer.value) {
				clearTimeout(sessionTimer.value);
			}

			sessionTimer.value = setTimeout(() => {
				shouldNotify.value = true;
			}, timeTillNotify);
		}
	}

	return shouldNotify;
};

const setSessionLimit = (exclusion: IGamingExclusion | undefined) => {
	const sessionLimitCookie: CookieRef<ISessionLimitCookie | null | undefined> = useCookie(cookieKey);
	if (exclusion) {
		if (exclusion && !sessionLimitCookie.value) {
			sessionLimitCookie.value = createCookieData(exclusion);
			setTimeout(() => {
				useSessionLimit();
			}, 500);
		}
	} else if (!exclusion && sessionLimitCookie.value) {
		sessionLimitCookie.value = null;
		if (sessionTimer.value) {
			clearTimeout(sessionTimer.value);
			sessionTimer.value = null;
		}
	}
};

const createCookieData = (sessionLimit: IGamingExclusion): ISessionLimitCookie | null => {
	if (sessionLimit.periodValue) {
		return {
			sessionStart: new Date(),
			periodValue: sessionLimit.periodValue,
			periodInterval: sessionLimit.periodInterval,
		};
	}

	return null;
};

const resetTimer = () => {
	const sessionCookie: CookieRef<ISessionLimitCookie | null | undefined> = useCookie(cookieKey);
	if (sessionCookie.value) {
		if (sessionTimer.value) {
			clearTimeout(sessionTimer.value);
			sessionTimer.value = null;
		}
		shouldNotify.value = false;
		sessionCookie.value.sessionStart = new Date();
		setTimeout(() => {
			useSessionLimit();
		}, 500);
	}
};

const clearTimer = () => {
	const sessionCookie: CookieRef<ISessionLimitCookie | null | undefined> = useCookie(cookieKey);
	sessionCookie.value = null;
	shouldNotify.value = false;
	if (sessionTimer.value) {
		clearTimeout(sessionTimer.value);
		sessionTimer.value = null;
	}
};

export { setSessionLimit, useSessionLimit, resetTimer, clearTimer };
